module.exports = __webpack_public_path__ + "static/media/the-library-book.ad3ea38d.jpg";